<template>
  <BasePageContent>
    <BasePageHeader
      class="px-3"
      title="Warehouses"
      description="Manage your warehouses"
    >
      <ul class="nk-block-tools g-1 pr-3">
        <li class="nk-block-tools-opt">
          <a
            href="#"
            title="Add new warehouse"
            class="btn btn-white btn-dim btn-outline-light"
            @click.prevent="Toggle = true"
          >
            <em class="dd-indc icon ni ni-plus"></em>
            <span class="d-inline">New warehouse</span>
            <em class="dd-indc w3-text-theme icon ni ni-chevron-right"></em>
          </a>
          <AddWarehouse
            :toggle-by="Toggle"
            @oncancel="SaveOnNew"
            @onsave="SaveOnNew"
            title="Add new warehouse"
          ></AddWarehouse>
        </li>
      </ul>
    </BasePageHeader>
    <div class="card-inner">
      <div class="px-1">
        <WarehouseList id="warehouseList" :warehouses="Warehouses" />
      </div>
    </div>
  </BasePageContent>
</template>
<script>
import { ref, computed } from "vue";
import { useRouter } from "vue-router";
import WarehouseList from "@/components/ui/warehouse/WarehouseList.vue";
import AddWarehouse from "@/components/ui/warehouse/AddWarehouse.vue";
import { Util } from "@/helpers/utilities";

import { useStore } from "vuex";
export default {
  components: {
    WarehouseList,
    AddWarehouse,
  },
  props: {
    addNew: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const store = useStore();
    const title = ref("Warehouses");
    const Warehouses = computed(() => store.getters["warehouses/warehouses"]);
    const Toggle = ref(props.addNew);
    const router = useRouter();
    const SaveOnNew = () => {
      if (props.addNew) {
        router.push({
          name: "warehouses",
        });
      } else {
        Toggle.value = false;
      }
    };
    return {
      title,
      Util,
      Warehouses,
      Toggle,
      SaveOnNew,
    };
  },
};
</script>